import React from 'react';
import { ModalHeader } from '../../../../../../CommonComponents/OPL/Modal/ModalHeader';
import { ModalBody } from '../../../../../../CommonComponents/OPL/Modal/ModalBody';
import { ModalFooter } from '../../../../../../CommonComponents/OPL/Modal/ModalFooter';
import { Button } from '../../../../../../CommonComponents/OPL/Button/Button';
import { Modal } from '../../../../../../CommonComponents/OPL/Modal/Modal';

const HEADER_ID = 'update-dependent-modal--header';

interface Props {
  onUpdateDependent(): void;
  onClose(): void;
}

export const UpdateDependentModal: React.FC<Props> = ({ onUpdateDependent, onClose }) => {
  return (
    <Modal
      isOpen
      onRequestClose={onClose}
      shouldCloseOnOverlayClick={false}
      aria={{ labelledby: HEADER_ID }}
      shouldReturnFocusAfterClose={false} // This prevents an issue when returning focus to the select
    >
      <ModalHeader as="h2" id={HEADER_ID}>
        Are you sure you want to change the beneficiary type?
      </ModalHeader>

      <ModalBody>
        Changing the type of this beneficiary may impact your goals and financial plan.
      </ModalBody>

      <ModalFooter>
        <Button variant="subtleInactive" onClick={onClose}>
          Cancel
        </Button>

        <Button
          onClick={() => {
            onUpdateDependent();
            onClose();
          }}
          ml="8"
        >
          Change Beneficiary Type
        </Button>
      </ModalFooter>
    </Modal>
  );
};
